export default __webpack_public_path__ + "static/media/wallet-card-theme5.635d787d.svg";